function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.4846 12.9917V16.325C19.4846 16.5417 19.4763 16.75 19.4513 16.95C19.2596 19.2 17.9346 20.3167 15.493 20.3167H15.1596C14.9513 20.3167 14.7513 20.4167 14.6263 20.5833L13.6263 21.9167C13.1846 22.5083 12.468 22.5083 12.0263 21.9167L11.0263 20.5833C10.918 20.4417 10.6763 20.3167 10.493 20.3167H10.1596C7.50131 20.3167 6.16797 19.6583 6.16797 16.325V12.9917C6.16797 10.55 7.29298 9.22501 9.53464 9.03334C9.73464 9.00834 9.94298 9 10.1596 9H15.493C18.1513 9 19.4846 10.3333 19.4846 12.9917Z",
  fill: "url(#paint0_linear_15376_421303)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.8255 15.6667C12.3589 15.6667 11.9922 15.2917 11.9922 14.8333C11.9922 14.375 12.3672 14 12.8255 14C13.2839 14 13.6589 14.375 13.6589 14.8333C13.6589 15.2917 13.2922 15.6667 12.8255 15.6667Z",
  fill: "#FFDC40"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.7396 15.6667C15.2729 15.6667 14.9062 15.2917 14.9062 14.8333C14.9062 14.375 15.2812 14 15.7396 14C16.1979 14 16.5729 14.375 16.5729 14.8333C16.5729 15.2917 16.1979 15.6667 15.7396 15.6667Z",
  fill: "#FFDC40"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.91536 15.6667C9.4487 15.6667 9.08203 15.2917 9.08203 14.8333C9.08203 14.375 9.45703 14 9.91536 14C10.3737 14 10.7487 14.375 10.7487 14.8333C10.7487 15.2917 10.3737 15.6667 9.91536 15.6667Z",
  fill: "#FFDC40"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.8146 9.65842V12.9918C22.8146 15.4418 21.6896 16.7584 19.4479 16.9501C19.4729 16.7501 19.4813 16.5418 19.4813 16.3251V12.9918C19.4813 10.3334 18.1479 9.00008 15.4896 9.00008H10.1562C9.93958 9.00008 9.73125 9.00842 9.53125 9.03342C9.72292 6.79176 11.0479 5.66675 13.4896 5.66675H18.8229C21.4812 5.66675 22.8146 7.00009 22.8146 9.65842Z",
  fill: "#0F0B6A"
});

var _ref8 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_15376_421303",
  x1: 19.7516,
  y1: 9,
  x2: 3.76,
  y2: 18.2289,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})));

var SvgHotroActive = function SvgHotroActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHotroActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hotro_active.0cf41201.svg";
export { ForwardRef as ReactComponent };